export default "__VITE_ASSET__44cad8e5__"